export const PaymentValidationResult = Object.freeze({
    Unset: 1,
    Approved: 2,
    Declined: 3
});